import { getSchema as getSchema1, uiSchema as uiSchema1 } from "./schema.kyc.1";
import { getInitialValues } from "./schema.kyc.utils";
export default (function (extraData) { return [
    {
        schema: getSchema1(getInitialValues(extraData)),
        uiSchema: uiSchema1(extraData),
    },
]; });
